import React, { Component } from "react";

import Header from "@components/Header";

class PluginsServers extends Component {
    render() {
        return (
            <div id="main">
                <Header />
                <section>
                    <header className="content">
                        <h1>PluginsServers</h1>
                    </header>
                </section>
            </div>
        );
    }
}

export default PluginsServers;
